// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + "compiled-css" + "." + "bfc801ab6b80ed4fd972" + ".css";
};